<template>
  <div :class="!hasGreeting && 'no-greeting'">
    <module-renderer :moduleData="moduleData" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

/**
 * Local state
 */
const assignment = ref(null)

/**
 * State
 */
const offer = computed(() => store.state.offer)

/**
 * Getter helper
 */
const findAssignments = (id) =>
  store.getters['assignments/find'](id)

/**
 * Computed
 */
const moduleData = computed(() => {
  // In this case the assignmentId (2nd param) is also the offerId
  // const { id: assignmentId } = this.$store.state.offer;
  // const assignment = this.findAssignments(assignmentId);
  return assignment.value?.modules || []
})

const hasGreeting = computed(() => {
  return moduleData.value.some(
    module => module.name === 'Greeting'
  )
})

/**
 * Actions
 */
const getAssignments = (payload) =>
  store.dispatch('assignments/getAssignments', payload)

/**
 * Lifecycle
 */
onMounted(async () => {
  const assignmentId = store.state.offer.id

  // Fetch assignments (async)
  await getAssignments({
    assignmentId,
    offerId: offer.value.id,
    type: 'offer'
  })

  // Read from store AFTER fetch
  const result = findAssignments(assignmentId)

  assignment.value = result instanceof Promise
    ? await result
    : result

    // console.log('assignment values (moduleData): ', assignment.value)
})
</script>

<style>
.update-modal.v3 {
  display: none !important;
}
</style>
